import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EditOutlined } from '@mui/icons-material';
import Table from '../../components/DevExpressTable/DevExpressTable';
import { columns } from './columns';
import { IActionColumn } from '../../components/DevExpressTable/ActionsColumn';
import { Container, Content, Button, DeleteIcon } from './styles';
import api from '../../services/api';
import { useToast } from '../../hooks/toast';
import Loading from '../../components/Loading';

interface Tag {
  tagId: number;
  type: string;
  category: string;
  category_2: string;
}

const Tag: React.FC = () => {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState<Tag[]>([]);

  const [tableColumnExtensions] = useState([
    { columnFilteringEnabled: true },
    { columnName: 'tagId', width: 120 },
  ]);

  const handleClickEdit = useCallback(
    (row: any) => {
      navigate(`/tags/edit/${parseInt(row.tagId, 10).toString()}`);
    },
    [navigate],
  );

  const handleDelete = useCallback(
    (row: any) => {
      // eslint-disable-next-line no-restricted-globals, no-alert
      const userWantDelete = confirm(
        `Are you sure you want to delete the categorie ${row.tagId} - ${row.category}?`,
      );

      if (userWantDelete) {
        api.delete(`/tags/${row.tagId}`).then(response => {
          if (response.data) {
            if (response.data.deleted) {
              addToast({
                type: 'success',
                title: 'Success',
                description: `The category ${row.tagId} was deleted successfully!`,
              });
              navigate('/projects');
              navigate('/tags');
            } else {
              addToast({
                type: 'info',
                title: 'Can not be deleted',
                description: response.data.message,
              });
            }
          } else {
            addToast({
              type: 'error',
              title: 'Deleting Error',
              description: `An error occurred while deleting this segement, please try again.`,
            });
          }
        });
      }
    },
    [addToast, navigate],
  );

  const [actionColumns] = useState<IActionColumn[]>([
    {
      columnName: 'delete',
      label: 'Delete',
      onClick: handleDelete,
      icon: <DeleteIcon />,
      width: 120,
    },
    {
      columnName: 'edit',
      label: 'Edit',
      onClick: row => handleClickEdit(row),
      icon: <EditOutlined />,
    },
  ]);

  useEffect(() => {
    setLoading(true);
    api.get('tags/getAllWithoutRules').then(response => {
      setTags(response.data);

      setLoading(false);
    });
  }, []);

  return (
    <Container className={loading ? 'loading' : ''}>
      <h1>Categories </h1>

      <Link
        to={{
          pathname: `/tags/new`,
        }}
      >
        <Button variant="contained" type="button">
          New Category
        </Button>
      </Link>

      {loading ? (
        <div style={{ display: 'flex' }}>
          <Loading />
        </div>
      ) : (
        <Content>
          <Table
            columnsProp={columns}
            dataProp={tags}
            checkboxSelection={false}
            tableColumnExtensions={tableColumnExtensions}
            actionColumns={actionColumns}
            idName={'tagId'}
            hasFilterRow={true}
          ></Table>
        </Content>
      )}
    </Container>
  );
};

export default Tag;
